'use strict';

var _ = require('lodash');
var $ = require('jquery');
var cssTemplate = require('../templates/css.ejs');

var PageView = require('standard-vote/app/scripts/views/page');

module.exports = PageView.extend({

    updateCSS: function(cms) {
        var text = cms.get('text');
        var design = text.design;
        var header = text.views_page_header;
        var footer = text.views_page_footer;
        var gridStyling = text.views_nominee_grid;
        var customCss = design.css;

        //create variables for custom CSS
        var templateVars = {
            uniqueId: this.uniqueId,
            header: _.extend( {}, customCss.header, header ),
            footer: _.extend( {}, customCss.footer, footer ),
            grid: _.extend( {}, customCss.grid, gridStyling ),
            voteButton: customCss.vote_button,
            customFonts: design.custom_fonts,
            closeButton: customCss.x_close_button,
            voteModal: customCss.vote_modal,
            emailButton: customCss.email_button,
            login: customCss.login,
            page: customCss.page_background,
            container: customCss.container_background,
            countdown: customCss.countdown,
            closed: customCss.closed_page,
            voteItem: customCss.vote_item,
            thanks: customCss.thanks,
            auth: customCss.auth
        };

        var randomId = 'style_' + Math.round(Math.random() * 1000000);
        var lastId = this.lastId;

        if (lastId) {
            console.info($('#' + this.lastId), $('#' + this.lastId).length);
            $('#' + this.lastId).remove();
        }

        var css = cssTemplate(templateVars);
        var style = $('<style />');

        style.prop('id', randomId)
            .append(css)
            .appendTo('head');

        this.lastId = randomId;
    }

});



// WEBPACK FOOTER //
// ./app/scripts/views/page.js